import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLeaguesService } from '../../../../services/leagues/api/api-leagues.service';
import { AlertsService } from '../../../../services/alerts.service';
import { ModalsService } from '../../../../services/modals.service';
import { LeagueReward } from '../../../../models/leagues/league-reward.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';
import { LeagueRewardAddModalComponent } from '../league-reward-add-modal/league-reward-add-modal.component';
import { LeagueRewardEditModalComponent } from '../league-reward-edit-modal/league-reward-edit-modal.component';

@Component({
  selector: 'app-league-rewards-modal',
  templateUrl: './league-rewards-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, LeagueRewardAddModalComponent, LeagueRewardEditModalComponent]
})
export class LeagueRewardsModalComponent {

  @ViewChild('modal') modal!: ModalDirective;
  @ViewChild('leagueRewardAddModal') leagueRewardAddModal!: LeagueRewardAddModalComponent;
  @ViewChild('leagueRewardEditModal') leagueRewardEditModal!: LeagueRewardEditModalComponent;

  isLoading: boolean = false;
  leagueId: number = 0;
  leagueName: string = '';
  rewards: LeagueReward[] = [];

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  constructor(
    private apiLeaguesService: ApiLeaguesService,
    private alertsService: AlertsService,
    private modalsService: ModalsService
  ) {}

  getCurrencyTypeName(type: number): string { return UserCurrencyType[type] ?? String(type); }

  show(leagueId: number, leagueName: string): void {
    this.leagueId = leagueId;
    this.leagueName = leagueName;
    this.rewards = [];
    this.isLoading = false;
    this.modal.show();
    this.refreshRewards();
  }

  onClickAddReward(): void {
    this.leagueRewardAddModal.show(this.leagueId, () => this.refreshRewards());
  }

  onClickEditReward(reward: LeagueReward): void {
    this.leagueRewardEditModal.show(reward, () => this.refreshRewards());
  }

  onClickDeleteReward(reward: LeagueReward): void {
    this.modalsService.showConfirmModal(() => {
      this.apiLeaguesService.deleteLeagueReward(reward.rewardId).then(
        () => {
          this.alertsService.displayAlertSuccess('Reward deleted !');
          this.refreshRewards();
        }, error => {
          this.alertsService.displayAlertError('Error deleting reward : ' + error);
        }
      );
    });
  }

  private refreshRewards(): void {
    this.isLoading = true;
    this.apiLeaguesService.getLeaguesRewards(this.leagueId).then(
      response => {
        this.isLoading = false;
        this.rewards = response.results;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading rewards : ' + error);
      }
    );
  }
}
